import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import type {
  TrialBalanceRequest,
  TrialBalanceResult,
} from "./trial-balance.models";

export class TrialBalanceServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }

  constructor(protected config: { basePath: string; token: string }) {}

  async fetchTrialBalance(
    body: TrialBalanceRequest = {}
  ): Promise<TrialBalanceResult> {
    const results: AxiosResponse<TrialBalanceResult> = await axios.post(
      this.config.basePath + `/accounting/trial-balance`,
      body,
      {
        headers: {
          Authorization: this.config.token,
        },
      }
    );
    return results.data;
  }
}

export const trialBalanceServices = new TrialBalanceServices(SDKConfig);
